import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';
import { authUserSetRateKanbanPoll } from '../../../../../../../rest/effects/authUser/authUserSetRateKanbanPoll';

export const onSkip = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentUserEvent.RATE_KANBAN_POLL_SKIPPED));
        dispatch(authUserSetRateKanbanPoll({
            lastTimeShowed: Date.now(),
            isSkipped: true
        }));
    };
    return action;
};
